import React from "react";

import styles from "./styles.css";


const BASE_LINE_HEIGHT_IN_FORM = 21;

export const LongTextAccordion = ({ value, lines = 3 }) => {
	const elementRef = React.useRef(null);
	const [ enabledShowMore, setEnabledShowMore ] = React.useState(false);
	const [ shortText, toggleShortText ] = React.useReducer((prev) => !prev, true);

	React.useLayoutEffect(() => {
		setEnabledShowMore(
			elementRef.current
				? elementRef.current.getBoundingClientRect().height > (lines * BASE_LINE_HEIGHT_IN_FORM)
				: false
		);
	}, [ value ]);

	return (
		<div className={styles.descriptionAccordion}>
			<div
				data-testid="accordion-container"
				ref={elementRef}
				className={enabledShowMore && shortText ? styles.shortText : styles.text}
				dangerouslySetInnerHTML={{ __html: value }}
			/>
			{enabledShowMore && (
				<button
					type="button"
					onClick={toggleShortText}
					className={styles.toggleShortTextButton}
					data-testid="toggle-show-more-btn"
				>
					{shortText ? "Click to expand" : "Click to collapse"}
					<svg className={shortText ? styles.toggleShowMoreCaret : styles.toggleShowMoreCaretRotate} width="10" height="6" viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg">
						<path d="M9.47656 1.50391L6.00391 5.00391C5.8125 5.16797 5.59375 5.25 5.375 5.25C5.12891 5.25 4.91016 5.16797 4.74609 5.00391L1.27344 1.50391C1 1.25781 0.917969 0.875 1.05469 0.546875C1.19141 0.21875 1.51953 0 1.875 0H8.84766C9.20312 0 9.50391 0.21875 9.64062 0.546875C9.77734 0.875 9.72266 1.25781 9.47656 1.50391Z" />
					</svg>
				</button>
			)}
		</div>
	);
};
